import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { configureApiClient } from "@shared/services/api/apiClient";
import "./styles/tailwind.css";
import "./styles/global.scss";
import App from "./App";

// Aplica configuración env-driven al cliente HTTP antes de montar React,
// para que cualquier hook que se ejecute durante el primer render ya
// tenga la API Key disponible.
configureApiClient();

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");
createRoot(root).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
